<template>
  <div>
    <v-container class="text-center" v-if="loading">
    <v-progress-circular class="loading" indeterminate color="#881E98"></v-progress-circular>
  </v-container>
  <v-list-item>
    <v-list-item-content>
      <v-row class="ml-1">
        <div class="overline mb-2 template-name"><strong>{{ this.templateConfig.Name }}</strong></div>
        <v-chip class="pa-2 ml-3 info-chip" outlined small>VM - CONNECTED</v-chip>
      </v-row>
      <span>
        <hr class="underscore" />
      </span>
      <v-container fluid>
        <v-text-field
          label="Environment domain prefix"
          class="environment-domain-prefix"
          v-model="environment.domainPrefix"
          :error="errors && !$v.environment.domainPrefix.required"
          :suffix="`.${selectedProvider}.platform.ttpsc.cloud`"
          :rules="[friendlyUrl]"
          :maxlength="63"
          @change="onSelectedDomain"
          persistent-hint
        ></v-text-field>

        <Sizes
          class="sizes"
          :errors="[errors, $v.environment.selectedSize.required]"
          @selectedSize="onSelectedSize"
          :sizes="vmSizes"
          v-if="templateConfig.Type === 'VM'"
        />
      </v-container>
    </v-list-item-content>
  </v-list-item>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import Sizes from "./Sizes";
import SSH from "./SSH";
import { validationMixin } from "vuelidate";

import { required, requiredIf, maxLength } from "vuelidate/lib/validators";

export default {
  data() {
    return {
      loading: false,
      templateName: "",
      runOn: "",
      environment: {
        selectedSize: "",
        name: "",
        domainPrefix: "",
        port: null
      },
      templateId: "",
      errors: false,
      domainPrefixError: false,
      vmSizes: [],
    };
  },
  components: { Sizes, SSH },
  props: ['templateConfig', 'selectedProvider'],
  mixins: [validationMixin],
  validations: {
    environment: {
      name: { required, maxLength: maxLength(50) },
      domainPrefix: { required, maxLength: maxLength(63) },
      selectedSize: {
        required: requiredIf(function() {
          return this.templateConfig.Type === "VM";
        })
      },
    }
  },
  computed: {
    ...mapGetters(["sizes"]),
  },
  methods: {
    ...mapActions([
      "getTemplateRegionInfo",
      "getTemplateVmSizes",
    ]),
    onSelectedSize(size) {
      const { selectedSize } = this.environment;
      this.environment.selectedSize = size === selectedSize ? null : size;

      const data = {
        templateId: this.templateConfig.TemplateId,
        instanceTypeId: this.environment.selectedSize
      }

      this.$emit('selectedSize', data)
    },
    friendlyUrl(value) {
      if (/^(?![0-9]+$)(?!.*-$)(?!-)[a-zA-Z0-9-]{1,63}$/.test(value)) {
        this.domainPrefixError = false;
        return true;
      }
      this.domainPrefixError = true;
      return "Domain prefix must contain only alphanumeric characters, can't be empty and could have max 63 characters!";
    },
    onSelectedDomain() {
      const data = {
        templateId: this.templateConfig.TemplateId,
        domainPrefix: this.environment.domainPrefix
      }

      this.$emit('selectedDomain', data);
    }
  },
  async created() {
    this.loading = true;
    await this.getTemplateVmSizes(this.templateConfig.TemplateId);
    this.vmSizes = this.sizes.map(size => ({ ...size, selected: false }));
    this.loading = false;
  }
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Montserrat&display=swap");
/* 
@media (min-width: 960px) {
  #run-environment-desktop {
    max-width: 40%;
    margin-top: 120px;
  }

  #environment-card {
    border: 0;
  }
}

@media (min-width: 600px) {
  #run-environment-title {
    font-size: 0.5em !important;
  }
} */

#run-environment-title {
  font-family: "Montserrat" !important;
  font-weight: bold;
  font-size: 1.7em !important;
}

.labels {
  font: 14px "Montserrat" !important;
  margin-top: 5px;
}

#run-button-style {
  font: 1em "Montserrat" !important;
  color: #fff;
  background: #6db42c;
  border-radius: 138px;
  width: 234px;
  height: 46px;
}

.cloud-title {
  padding-bottom: 20px;
  padding-top: 20px;
  font: Bold 16px/19px "Montserrat" !important;
}

.environment-name {
  height: 40px;
}

.environment-domain-prefix {
  height: 40px;
  /* margin-top: 15px; */
  margin-top: 2vh;
}

.scheduler {
  background: #f9f9f9;
}
form {
  font-family: "Montserrat" !important;
}

.title-icon {
  color: black !important;
  margin-right: 20px;
  font: 1.7em "Font Awesome 5 Pro" !important;
}

#cancel-button {
  font: 1em "Montserrat" !important;
  border-radius: 138px;
  width: 234px;
  height: 46px;
}
.underscore {
  border: 1.5px solid #6db42c;
  border-radius: 1px;
  width: 100px;
  margin-right: 100%;
  margin-top: 10px;
  margin-bottom: 2px;
  background-color: #6db42c;
}

.providers {
  margin-top: 15px;
}

.providers-non-selected {
  margin-bottom: 55px;
}

.region-select {
  margin-top: 30px;
  margin-bottom: 60px;
}

.actions {
  margin-top: 60px;
  height: 130px;
  width: 100%;
}

.actions-scheduler-disabled {
  margin-top: 10px;
  height: 130px;
  width: 100%;
}

.estimated-cost-container {
  text-align: center;
  margin-top: 60px;
}

.estimated-cost-paragraph {
  font: bold 24px/29px "Montserrat";
  display: inline;
  margin-right: 20px;
}

.estimated-amount-paragraph {
  display: inline;
  font: bold 24px/29px "Montserrat";
  color: #d0398b;
  margin-right: 5px;
}

.slash {
  color: #bbbbbb;
  display: inline;
  font: 24px/29px "Montserrat";
}

.loading {
  margin-top: 24px;
}

.template-name {
  font-size: 0.9em !important;
  font-family: "Montserrat";
}

.sizes {
  margin-top: 3vh;
  margin-bottom: 3vh;
}

.info-chip {
  color: #881e98;
  font-weight: bold;
  font-size: 0.7rem;
  border-color: #881e98 !important;
  height: 16px;
  margin-top: -1px;
}
</style>
